<h1 mat-dialog-title>{{ 'WORKCLASSIFICATION.TEMPLATES.COPY_TO.TITLE' | translate }}</h1>
<div mat-dialog-content>
  <p>
    {{ 'WORKCLASSIFICATION.TEMPLATES.COPY_TO.INTRO' | translate }}

  </p>
  <mat-card class="warning-card m-1">
    <mat-card-header>
      <mat-icon aria-hidden="false" aria-label="Warning icon">warning</mat-icon>
      <mat-card-title>{{"WARNING"|translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>{{ 'WORKCLASSIFICATION.TEMPLATES.COPY_TO.WARNING' | translate }}</p>



    </mat-card-content>

  </mat-card>
  <mat-form-field appearance="fill">
    <mat-select [placeholder]="'WORKCLASSIFICATION.TEMPLATES.COPY_TO.SELECT_PROJECT' | translate" [(ngModel)]="selectedProjectId">
      @for (project of selectableProjects|async; track project) {
        <mat-option [value]="project.id">
          {{project.costCenterNumber}} - {{project.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-button class="btn-secondary" matDialogClose>{{'Cancel'|translate}}</button>
  <button mat-raised-button class="btn-primary" [mat-dialog-close]="selectedProjectId" [disabled]="!selectedProjectId" cdkFocusInitial> <mat-icon>content_copy</mat-icon> {{ 'WORKCLASSIFICATION.TEMPLATES.COPY_TO.CONFIRM' | translate }}</button>
</div>
